import * as React from "react";
import type { SVGProps } from "react";
const SvgDownload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.215 20.423c.394.397.928.62 1.485.62h12.6a2.1 2.1 0 0 0 1.485-.62M12 2.957v12m0 0 4.8-4.586m-4.8 4.586-4.8-4.586"
    />
  </svg>
);
export default SvgDownload01;
